import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { OrderContext } from "../../context/OrderContext";
import { ProductContext } from "../../context/ProductsContext";
import CheckoutDelivery from "../../components/OrderPage/CheckoutDelivery";
import bdLocations from '../locations';
import { useParams } from "react-router-dom";
import { trackEventOnMultiplePixels } from "../../pixel";
import { 
  FaUser, 
  FaPhoneAlt, 
  FaMapMarkerAlt, 
  FaMap, 
  FaCity, 
  FaPalette,
  FaRulerVertical,
  FaTshirt,
  FaShoppingCart,
  FaTruck,
  FaMoneyBillWave
} from "react-icons/fa";
import axios from "axios";
import DeliveryCharge from "./DeliveryCharge";
import HelpSectuion from "../../components/Landing/HelpSectuion";

const CheckoutSection = () => {

  const {
    apiUrl,
    imageUrl,
    name,
    address,
    phone,
    deliveryCharge,
    setDeliveryCharge,
    estimatedDays,
    setEstimatedDays,
    selectedDistrict,
    setSelectedDistrict,
    deliveryNote,
    setName,
    setAddress,
    setPhone,
    districts: districtData,
  } = useContext(OrderContext);
  
  const { pixel, testEventCode } = useContext(ProductContext);

  const [price, setPrice] = useState(0);
  const [selectedDeliveryCharge, setSelectedDeliveryCharge] = useState(0);
  const [deliveryArea, setDeliveryArea] = useState([]);
  const [qty, setQty] = useState(1);

  const [bumps, setBumps] = useState([]);
  const [selectedBumps, setSelectedBumps] = useState([]);

  const bumpPriceTotal = selectedBumps.reduce(
    (sum, bump) => sum + Number(bump.bump_price),
    0
  );

  const [selectedBulkDiscount, setSelectedBulkDiscount] = useState(null);

  const discountedSubtotal = useMemo(() => {
      if (selectedBulkDiscount && qty === selectedBulkDiscount.offer_quantity) {
        const discountAmount = (price * qty * selectedBulkDiscount.discount_percentage) / 100;
        return Math.round(price * qty - discountAmount);
      }
      return Math.round(price * qty);
  }, [price, qty, selectedBulkDiscount]);

  const subtotal = discountedSubtotal;

  // Ensure total is perfectly rounded and numeric
  const total = Math.round(Number(subtotal || 0) + Number(selectedDeliveryCharge || 0) + Number(bumpPriceTotal || 0));

  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedSingleSize, setSelectedSingleSize] = useState(null);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const { slug } = useParams();

  const randomNumber = `HA${Math.floor(1000 + Math.random() * 90000)}`;
  const [orderId] = useState(randomNumber);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const token = localStorage.getItem('authToken') || null;
  
  const [divisions, setDivisions] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState('');
  const [selectedDivisionName, setSelectedDivisionName] = useState('');
  const [selectedDistrictName, setSelectedDistrictName] = useState('');
  const [checkoutTracked, setCheckoutTracked] = useState(false);

  const [phoneError, setPhoneError] = useState("");

  // Helper function to get cookies
  const getCookie = (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
  };

    const generateFBC = () => {

        const existing = getCookie('_fbc');
        if (existing) return existing;

        const urlParams = new URLSearchParams(window.location.search);
        const fbclid = urlParams.get('fbclid');

        if (!fbclid) return null;

        const timestamp = Date.now();
        const fbc = `fb.1.${timestamp}.${fbclid}`;

        document.cookie = `_fbc=${fbc};path=/;max-age=7776000`;

        return fbc;
      };

    useEffect(() => {

      const fbc = generateFBC();
      const fbp = getCookie('_fbp');

      if (fbc) localStorage.setItem('fbc', fbc);
      if (fbp) localStorage.setItem('fbp', fbp);

    }, []);


    const getFBC = () => {
      return getCookie('_fbc') || localStorage.getItem('fbc') || null;
    };

    const getFBP = () => {
      return getCookie('_fbp') || localStorage.getItem('fbp') || null;
    };

  useEffect(() => {
    const fetchLandingData = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${apiUrl}/landing-pages/offer/${slug}`);
        const result = await response.json();
        setData(result.data);
        setPrice(result.data?.product?.discount_price || result.data?.product?.price);

      } catch (err) {
        setError('Failed to load landing page data.');
      } finally {
        setLoading(false);
      }
    };
    fetchLandingData();
  }, [apiUrl, slug]);


  useEffect(() => {
    const fetchDeliveryData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${apiUrl}/deliverycharges`);
        setDeliveryArea(response.data);
      } catch (err) {
        setError('Failed to load delivery charges data.');
      } finally {
        setLoading(false);
      }
    };
    fetchDeliveryData();
  }, [apiUrl]);

  useEffect(() => {
    if (data?.product?.bumps) {
      setBumps(
        data.product.bumps.map(b => ({
          ...b,
          selected: false
        }))
      );
    }
  }, [data]);

  const handleBumpSelect = (bumpId) => {
    setBumps(prev =>
      prev.map(b =>
        b.id === bumpId ? { ...b, selected: !b.selected } : b
      )
    );

    setSelectedBumps(prev => {
      const exists = prev.find(b => b.id === bumpId);
      if (exists) {
        return prev.filter(b => b.id !== bumpId);
      } else {
        const bumpToAdd = bumps.find(b => b.id === bumpId);
        return bumpToAdd ? [...prev, bumpToAdd] : prev;
      }
    });
  };

  const handleQtyChange = (newQty) => {
    setQty(newQty);
  };

  // Memoized values
  const handleBulkDiscountSelect = (discount) => {
    setSelectedBulkDiscount(discount);
    setQty(discount.offer_quantity);   
  };
    
  // 1. ViewContent Tracking
    const viewContentTracked = useRef(false);

    useEffect(() => {
      if (!data?.product || !pixel?.length || viewContentTracked.current) return;

      const eventId = `VC_${Date.now()}_${Math.floor(Math.random() * 999999)}`;

      const eventData = {
        content_ids: [String(data.product.id)],
        contents: [
          {
            id: String(data.product.id),
            quantity: 1,
            item_price: Math.round(data.product.discount_price || data.product.price)
          }
        ],
        content_name: data.product.name,
        content_type: 'product',
        value: Math.round(Number(data.product.discount_price || data.product.price)),
        currency: 'BDT',
        event_source_url: window.location.href,
        fbc: getFBC(),
        fbp: getFBP(),
        external_id: orderId
      };

      // (A) Pixel ViewContent
      trackEventOnMultiplePixels(pixel, "ViewContent", {
        ...eventData,
        event_id: eventId
      });

      // (B) Server-side CAPI ViewContent
      axios
        .post(`${apiUrl}/fb-track`, {
          event: "ViewContent",
          event_id: eventId,
          ...(testEventCode?.[0] && { test_event_code: testEventCode[0] }),
          ...eventData
        })
        .catch(err => console.log("CAPI ViewContent Error:", err));

      viewContentTracked.current = true;
    }, [data?.product, pixel]);

  // 2. InitiateCheckout Tracking Function
  const fireInitiateCheckout = () => {
      if (checkoutTracked) return;
      setCheckoutTracked(true);

      const eventId = `IC_${Math.floor(Date.now() / 1000)}_${Math.floor(Math.random() * 9000)}`;
      const bumpTotal = selectedBumps.reduce((sum, b) => sum + Number(b.bump_price), 0);
      const finalEventValue = Math.round(subtotal + bumpTotal); 
      const formattedPhone = phone.startsWith("0")
      ? "88" + phone
      : phone;

      const eventData = {

        value: finalEventValue, 
        currency: 'BDT',
        content_name: data?.product?.name,
        content_type: 'product',
        content_ids: [
          String(data?.product?.id),
          ...selectedBumps.map(b => `bump_${b.id}`)
        ],
        contents: [
          {
            id: String(data?.product?.id),
            quantity: qty,
            item_price: Math.round(price)
          },
          ...selectedBumps.map(b => ({
            id: `bump_${b.id}`,
            quantity: 1,
            item_price: Math.round(b.bump_price)
          }))
        ],
        event_source_url: window.location.href,
        fbc: getFBC(),
        fbp: getFBP(),
        external_id: orderId,
        phone: formattedPhone,
      };

      // Client-side Pixel
      trackEventOnMultiplePixels(pixel, 'InitiateCheckout', {
        ...eventData,
        event_id: eventId 
      });

      // Server-side CAPI
      axios.post(`${apiUrl}/fb-track`, {
          event: 'InitiateCheckout',
          ...(testEventCode?.[0] && { test_event_code: testEventCode[0] }),
          event_id: eventId,
          ...eventData
      }).catch(err => console.error("CAPI Tracking Error:", err));
  };

  const handleFormInteraction = () => {

    if (checkoutTracked) return;

    // phone না থাকলে event fire হবে না
    if (!phone || phone.length < 11) return;

    fireInitiateCheckout();
  };

  const handleDeliveryChange = (charge) => {
    setSelectedDeliveryCharge(charge);
  }

  const orderItems = [{
    product_id: data?.product?.id,
    product_name: data?.product?.name,
    quantity: qty,
    price: Math.round(data?.product?.discount_price || data?.product?.price),
    color: selectedColor || null,
    size: selectedSize || null,
  }];

  const orderData = {
    order_id: orderId,
    product_name: data?.product?.name,
    customer_name: name,
    phone_number: phone,
    customer_address: `Village/Road: ${address}, District: ${selectedDistrictName}, Division: ${selectedDivisionName}`,
    delivery_charge: String(Math.round(selectedDeliveryCharge || 0)),
    total: String(Math.round(total)),
    payment_method: 'cod',
    delivery_note: deliveryNote,
    items: orderItems,
    bumps: selectedBumps,
    bulk_discounts: selectedBulkDiscount ? [{ id: selectedBulkDiscount.id }] : [],
    product_price: String(Math.round(data?.product?.discount_price ? data?.product?.discount_price * qty : data?.product?.price * qty)),
    quantity: qty || 1,
  };


  // বিভাগ লোড
  useEffect(() => {
    const loadedDivisions = bdLocations.map(div => ({
      id: div.division.en,
      name: div.division.en,
      bn_name: div.division.bn
    }));
    setDivisions(loadedDivisions);
  }, []);

  // বিভাগ পরিবর্তন হলে সংশ্লিষ্ট জেলা লোড করুন
  useEffect(() => {
    if (selectedDivision) {
      const selectedDivData = bdLocations.find(div => div.division.en === selectedDivision);
      if (selectedDivData) {
        const loadedDistricts = selectedDivData.districts.map(dist => ({
          id: dist.en,
          name: dist.en,
          bn_name: dist.bn
        }));
        setDistricts(loadedDistricts);
      }
    } else {
      setDistricts([]);
    }
  }, [selectedDivision]);

  const handleDistrictChange = (districtName) => {
    const districtInfo = districtData.find(d => d.district_name === districtName);
    if (districtInfo) {
      setDeliveryCharge(districtInfo.delivery_charge);
      setEstimatedDays(districtInfo.estimated_days);
    }
    setSelectedDistrictName(districtName);
    setSelectedDistrict(districtName);
  };

  const handleColorSelect = (color) => {
    setSelectedColor(color);
    setSelectedSize(null);
  };

  const handleSizeSelect = (size) => {
    setSelectedSize(size);
  };

  const handleSingleSizeSelect = (singleSize) => {
    setSelectedSingleSize(singleSize);
  };

  // ফোন নাম্বার বাংলা থেকে ইংরেজি করার ফাংশন
  const handlePhoneChange = (e) => {
    const input = e.target.value;
    const bengaliToEnglish = {'০':'0', '১':'1', '২':'2', '৩':'3', '৪':'4', '৫':'5', '৬':'6', '৭':'7', '৮':'8', '৯':'9'};
    
    // বাংলা ডিজিট রিপ্লেস
    let convertedNumber = input.replace(/[০-৯]/g, match => bengaliToEnglish[match]);
    // ইংরেজি সংখ্যা ছাড়া সব মুছে ফেলা
    convertedNumber = convertedNumber.replace(/\D/g, '');
    
    setPhone(convertedNumber);

    if (convertedNumber.length > 0 && convertedNumber.length < 11) {
      setPhoneError("মোবাইল নম্বর অবশ্যই ১১ ডিজিটের হতে হবে");
    } else if (convertedNumber.length === 11 && !convertedNumber.startsWith("01")) {
      setPhoneError("সঠিক বাংলাদেশি মোবাইল নম্বর দিন (যেমন: 01...)");
    } else {
      setPhoneError(""); 
    }
  };

  const handleOrderConfirm =  async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

   try {
    const response = await axios.post(`${apiUrl}/customers`, orderData);
    if(response.status === 200 || response.status === 201){
       window.location.href = `/thankyou/${orderId}`;
    }
   } catch (error) {
    console.error('Order confirmation failed:', error);
    alert(error?.response?.data?.message || "অর্ডারটি সম্পন্ন করতে সমস্যা হয়েছে। দয়া করে আবার চেষ্টা করুন।");
    setIsSubmitting(false);
   }
  };




  // Auto save lead on tab close / page refresh
  useEffect(() => {
    const handleBeforeUnload = () => {

      if (isSubmitting) return;
      if (!name?.trim() || !phone?.trim() || !data?.product?.id) return;

      const leadData = {
        order_id: orderId,
        product_id: data.product.id,
        customer_name: name,
        phone_number: phone,
        product_name: data.product.name,
        product_price: Math.round(
          data.product.discount_price 
            ? data.product.discount_price * qty 
            : data.product.price * qty
        ),
        quantity: qty || 1,
        color: selectedColor?.color || null,
        size: selectedSize?.size || selectedSingleSize?.size || null,
        page_url: window.location.href,
        customer_address: `Village/Road: ${address || ''}, District: ${selectedDistrictName || ''}, Division: ${selectedDivisionName || ''}`
      };

      const blob = new Blob([JSON.stringify(leadData)], { type: "application/json" });

      navigator.sendBeacon(`${apiUrl}/leads`, blob);
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [
    isSubmitting,
    name, phone, address,
    selectedDistrictName, selectedDivisionName,
    qty, selectedColor, selectedSize, selectedSingleSize,
    data?.product, apiUrl, orderId
  ]);

  const hasCustomizationOptions = data?.product?.colors?.length > 0 || data?.product?.single_product_sizes?.length > 0;
  const hasColors = data?.product?.colors?.length > 0;
  const hasSingleProductSizes = data?.product?.single_product_sizes?.length > 0;

  return (
    <div className="bg-gradient-to-b from-gray-50 to-gray-100 min-h-screen py-8 px-4">
      <div className="max-w-7xl mx-auto">

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Left Column - Billing & Shipping */}
          <div className="space-y-6">
            
            {/* ⚠️ FORM WRAPPER FOR INITIATE CHECKOUT */}
            <div onFocus={handleFormInteraction} onClick={handleFormInteraction}>
                
                {/* Personal Information Card */}
                <div className="bg-white rounded-2xl shadow-lg p-6 transform transition-all duration-300 hover:shadow-xl mb-6">
                  <div className="flex items-center gap-3 mb-6 pb-4 border-b">
                    <div className="p-2 bg-blue-100 rounded-lg">
                      <FaUser className="text-blue-600 text-xl" />
                    </div>
                    <h2 className="text-2xl font-bold text-gray-800">ব্যক্তিগত তথ্য</h2>
                  </div>

                  <div className="space-y-6">
                    {/* Name Input */}
                    <div className="relative group">
                      <label className="block text-sm font-semibold mb-2 text-gray-700 flex items-center gap-2">
                        <FaUser className="text-gray-500" />
                        আপনার নাম লিখুন *
                      </label>
                      <div className="relative">
                        <input
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          type="text"
                          placeholder="আপনার সম্পূর্ণ নাম"
                          className="w-full px-4 py-3 pl-12 rounded-xl border-2 border-gray-300 focus:border-green-500 focus:ring-2 focus:ring-green-200 transition-all duration-300 bg-gray-50 focus:bg-white"
                        />
                        <div className="absolute left-4 top-1/2 transform -translate-y-1/2">
                          <FaUser className="text-gray-400" />
                        </div>
                      </div>
                    </div>

                    {/* Phone Input */}
                    <div className="relative group">
                      <label className="block text-sm font-semibold mb-2 text-gray-700 flex items-center gap-2">
                        <FaPhoneAlt className="text-gray-500" />
                        ১১ ডিজিটের মোবাইল নম্বর *
                      </label>
                      <div className="relative">
                        <input
                          type="tel"
                          value={phone}
                          maxLength="11"
                          onChange={handlePhoneChange}
                          placeholder="01XXXXXXXXX"
                          className={`w-full px-4 py-3 pl-12 rounded-xl border-2 transition-all duration-300 bg-gray-50 focus:bg-white ${
                            phoneError 
                              ? 'border-red-500 focus:ring-2 focus:ring-red-200' 
                              : 'border-gray-300 focus:border-green-500 focus:ring-2 focus:ring-green-200'
                          }`}
                        />
                        <div className="absolute left-4 top-1/2 transform -translate-y-1/2">
                          <FaPhoneAlt className={phoneError ? "text-red-400" : "text-gray-400"} />
                        </div>
                      </div>
                      
                      {phoneError ? (
                        <p className="text-xs text-red-500 mt-1 font-medium">{phoneError}</p>
                      ) : (
                        <p className="text-xs text-gray-500 mt-1">আমরা ডেলিভারি সম্পর্কে আপনাকে কল করব</p>
                      )}
                    </div>
                  </div>
                </div>

                {/* Shipping Address Card */}
                <div className="bg-white rounded-2xl shadow-lg p-6 transform transition-all duration-300 hover:shadow-xl">
                  <div className="flex items-center gap-3 mb-6 pb-4 border-b">
                    <div className="p-2 bg-green-100 rounded-lg">
                      <FaMapMarkerAlt className="text-green-600 text-xl" />
                    </div>
                    <h2 className="text-2xl font-bold text-gray-800">ডেলিভারি ঠিকানা</h2>
                  </div>

                  <div className="space-y-6">
                    {/* Division Select */}
                    <div className="relative group">
                      <label className="block text-sm font-semibold mb-2 text-gray-700 flex items-center gap-2">
                        <FaMap className="text-gray-500" />
                        বিভাগ সিলেক্ট করুন *
                      </label>
                      <div className="relative">
                        <select
                          value={selectedDivisionName}
                          onChange={(e) => {
                            const selectedOption = e.target.options[e.target.selectedIndex];
                            setSelectedDivision(selectedOption.id);
                            setSelectedDivisionName(selectedOption.value);
                            setSelectedDistrictName('');
                          }}
                          className="w-full px-4 py-3 pl-12 rounded-xl border-2 border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-300 bg-gray-50 focus:bg-white appearance-none"
                        >
                          <option value="">বিভাগ সিলেক্ট করুন</option>
                          {divisions.map((division) => (
                            <option key={division.id} id={division.id} value={division.name}>
                              {division.bn_name}
                            </option>
                          ))}
                        </select>
                        <div className="absolute left-4 top-1/2 transform -translate-y-1/2">
                          <FaMap className="text-gray-400" />
                        </div>
                        <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                          <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                          </svg>
                        </div>
                      </div>
                    </div>

                    {/* District Select */}
                    <div className="relative group">
                      <label className="block text-sm font-semibold mb-2 text-gray-700 flex items-center gap-2">
                        <FaCity className="text-gray-500" />
                        জেলা সিলেক্ট করুন *
                      </label>
                      <div className="relative">
                        <select
                          value={selectedDistrictName}
                          onChange={(e) => handleDistrictChange(e.target.value)}
                          className={`w-full px-4 py-3 pl-12 rounded-xl border-2 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-300 appearance-none ${!selectedDivision ? 'border-gray-200 bg-gray-100 text-gray-400' : 'border-gray-300 bg-gray-50 focus:bg-white'}`}
                          disabled={!selectedDivision}
                        >
                          <option value="">জেলা সিলেক্ট করুন</option>
                          {districts.map((district) => (
                            <option key={district.id} value={district.name}>
                              {district.bn_name}
                            </option>
                          ))}
                        </select>
                        <div className="absolute left-4 top-1/2 transform -translate-y-1/2">
                          <FaCity className={!selectedDivision ? "text-gray-300" : "text-gray-400"} />
                        </div>
                        {selectedDivision && (
                          <div className="absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none">
                            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                            </svg>
                          </div>
                        )}
                      </div>
                      {!selectedDivision && (
                        <p className="text-xs text-amber-600 mt-1">প্রথমে বিভাগ সিলেক্ট করুন</p>
                      )}
                    </div>

                    {/* Detailed Address */}
                    <div className="relative group">
                      <label className="block text-sm font-semibold mb-2 text-gray-700 flex items-center gap-2">
                        <FaMapMarkerAlt className="text-gray-500" />
                        বিস্তারিত ঠিকানা *
                      </label>
                      <textarea
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        placeholder="গ্রাম/মহল্লা, রোড নং, বাড়ি নং, থানা"
                        rows="4"
                        className="w-full px-4 py-3 rounded-xl border-2 border-gray-300 focus:border-green-500 focus:ring-2 focus:ring-green-200 transition-all duration-300 bg-gray-50 focus:bg-white resize-none"
                      />
                    </div>

                  </div>
                </div>
            </div>
            {/* ⚠️ END FORM WRAPPER */}
            
          </div>

          {/* Right Column - Order Summary */}
          <div className="space-y-6">
            {/* Product Customization Card */}
            {hasCustomizationOptions && (
              <div className="bg-white rounded-2xl shadow-lg p-6 transform transition-all duration-300 hover:shadow-xl">
                <div className="flex items-center gap-3 mb-6 pb-4 border-b">
                  <div className="p-2 bg-purple-100 rounded-lg">
                    <FaPalette className="text-purple-600 text-xl" />
                  </div>
                  <h2 className="text-2xl font-bold text-gray-800">পণ্য কাস্টোমাইজেশন</h2>
                </div>

                <div className="space-y-6">
                  {/* Color Selection */}
                  {hasColors && (
                    <div>
                      <div className="flex items-center gap-2 mb-4">
                        <FaPalette className="text-gray-500" />
                        <h3 className="font-semibold text-lg text-gray-800">পছন্দের কালার সিলেক্ট করুন</h3>
                      </div>
                      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                        {data.product.colors.map((colorItem) => (
                          <button
                            key={colorItem.id}
                            onClick={() => handleColorSelect(colorItem)}
                            className={`p-3 rounded-xl border-2 transition-all duration-300 ${selectedColor?.id === colorItem.id
                              ? 'border-green-500 bg-green-50 shadow-md transform scale-[1.02]'
                              : 'border-gray-200 hover:border-green-300 hover:shadow-sm'
                              }`}
                          >
                            <div className="flex flex-col items-center gap-2">
                              {colorItem.image && (
                                <img
                                  src={`${imageUrl}/${colorItem.image}`}
                                  alt={colorItem.color}
                                  className="w-16 h-16 rounded-full border-2 border-gray-200 object-cover"
                                />
                              )}
                              <span className={`font-medium ${selectedColor?.id === colorItem.id ? 'text-green-600' : 'text-gray-700'}`}>
                                {colorItem.color}
                              </span>
                            </div>
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Color Size Selection */}
                  {selectedColor?.sizes && selectedColor.sizes.length > 0 && (
                    <div>
                      <div className="flex items-center gap-2 mb-4">
                        <FaRulerVertical className="text-gray-500" />
                        <h3 className="font-semibold text-lg text-gray-800">কালারের জন্য সাইজ সিলেক্ট করুন</h3>
                      </div>
                      <div className="flex flex-wrap gap-3">
                        {selectedColor.sizes.map((sizeItem) => (
                          <button
                            key={sizeItem.id}
                            onClick={() => handleSizeSelect(sizeItem)}
                            className={`px-5 py-2.5 rounded-lg border-2 font-medium transition-all duration-300 ${selectedSize?.id === sizeItem.id
                              ? 'border-blue-500 bg-blue-50 text-blue-600 shadow-md'
                              : 'border-gray-300 hover:border-blue-400 hover:shadow-sm'
                              }`}
                          >
                            {sizeItem.size}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Single Product Size Selection */}
                  {hasSingleProductSizes && (
                    <div>
                      <div className="flex items-center gap-2 mb-4">
                        <FaTshirt className="text-gray-500" />
                        <h3 className="font-semibold text-lg text-gray-800">পণ্যের সাইজ সিলেক্ট করুন</h3>
                      </div>
                      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-3">
                        {data.product.single_product_sizes.map((singleSizeItem) => (
                          <button
                            key={singleSizeItem.id}
                            onClick={() => handleSingleSizeSelect(singleSizeItem)}
                            className={`py-3 rounded-lg border-2 font-medium transition-all duration-300 ${selectedSingleSize?.id === singleSizeItem.id
                              ? 'border-purple-500 bg-purple-50 text-purple-600 shadow-md'
                              : 'border-gray-300 hover:border-purple-400 hover:shadow-sm'
                              }`}
                          >
                            {singleSizeItem.size}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Order Summary Card */}
            <div className="bg-white rounded-2xl shadow-lg p-6 transform transition-all duration-300 hover:shadow-xl">
              <div className="flex items-center gap-3 mb-6 pb-4 border-b">
                <div className="p-2 bg-orange-100 rounded-lg">
                  <FaShoppingCart className="text-orange-600 text-xl" />
                </div>
                <h2 className="text-2xl font-bold text-gray-800">অর্ডার সামারি</h2>
              </div>

              {/* Selected Product Details */}
              <div className="mb-6 p-4 md:p-6 bg-gray-50 rounded-2xl border border-gray-200">
                
                {/* Product Name */}
                <h4 className="font-bold text-lg md:text-xl text-gray-800 mb-3">
                  {data?.product?.name}
                </h4>

                {/* Selected Attributes */}
                <div className="space-y-1 text-sm text-gray-600 mb-4">
                  {selectedColor && (
                    <div className="flex items-center gap-2">
                      <span
                        className="w-3 h-3 rounded-full"
                        style={{ backgroundColor: selectedColor.color === 'Red' ? '#ef4444' : '#3b82f6' }}
                      />
                      <span>কালার: {selectedColor.color}</span>
                    </div>
                  )}

                  {selectedSize && (
                    <div className="flex items-center gap-2">
                      <FaRulerVertical className="text-gray-400" />
                      <span>কালারের সাইজ: {selectedSize.size}</span>
                    </div>
                  )}

                  {selectedSingleSize && (
                    <div className="flex items-center gap-2">
                      <FaTshirt className="text-gray-400" />
                      <span>পণ্যের সাইজ: {selectedSingleSize.size}</span>
                    </div>
                  )}
                </div>

                {/* Bulk Discount Section */}
                {data?.product?.bulk_discounts?.length > 0 && (
                  <div className="bg-white rounded-xl border border-gray-200 p-3 md:p-4 mb-4">
                    <h5 className="font-semibold text-gray-800 mb-3">
                      একাধিক পণ্যে বিশেষ ছাড়
                    </h5>

                    <div className="space-y-3">
                      {data.product.bulk_discounts.map((discount) => {
                        const isSelected = selectedBulkDiscount?.id === discount.id;
                        const isExactQuantity = qty === discount.offer_quantity;

                        return (
                          <div
                            key={discount.id}
                            onClick={() => handleBulkDiscountSelect(discount)}
                            className={`p-3 rounded-lg border cursor-pointer transition-all ${
                              isSelected
                                ? 'border-blue-500 bg-blue-50 ring-2 ring-blue-200'
                                : 'border-gray-200 hover:border-blue-300'
                            }`}
                          >
                            <div className="flex justify-between items-center">
                              <div>
                                <p className="font-medium text-gray-800">
                                  {discount.title}
                                </p>

                                {!isExactQuantity && isSelected && (
                                  <p className="text-xs text-red-500 mt-1">
                                    এই অফার পেতে {discount.offer_quantity} টি নিতে হবে
                                  </p>
                                )}
                              </div>

                              <span className="px-2 py-1 rounded-full text-sm font-bold bg-green-100 text-green-800">
                                {discount.discount_percentage}% ছাড়
                              </span>
                            </div>

                            <p className="text-xs text-gray-500 mt-1">
                              শুধুমাত্র {discount.offer_quantity} টি অর্ডারে প্রযোজ্য
                            </p>

                            {isSelected && isExactQuantity && (
                              <p className="text-xs text-blue-600 mt-1">
                                ✔️ এই অফারটি সক্রিয়
                              </p>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

                {/* Quantity + Price */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                  
                  {/* Quantity Selector */}
                  <div className="flex items-center gap-3">
                    <button
                      onClick={() => handleQtyChange(qty > 1 ? qty - 1 : 1)}
                      className="w-10 h-10 rounded-lg bg-gray-200 hover:bg-gray-300 flex items-center justify-center"
                    >
                      −
                    </button>

                    <span className="w-12 text-center font-bold text-lg">
                      {qty}
                    </span>

                    <button
                      onClick={() => handleQtyChange(qty + 1)}
                      className="w-10 h-10 rounded-lg bg-green-500 hover:bg-green-600 text-white flex items-center justify-center"
                    >
                      +
                    </button>
                  </div>

                  {/* Subtotal */}
                  <div className="text-right">
                    <p className="text-sm text-gray-500">মূল্য</p>
                    <p className="text-xl font-bold text-gray-800">
                      {subtotal}৳
                    </p>
                  </div>

                </div>
              </div>

              {/* Delivery Area Selection */}
              <div className="mb-6">
                <DeliveryCharge 
                  handleDeliveryChange={handleDeliveryChange} 
                  deliveryArea = {deliveryArea} 
                  setSelectedDeliveryCharge={setSelectedDeliveryCharge} 
                />
              </div>

              {/* Order Totals */}
              <div className="mb-6">
                <div className="flex justify-between items-center py-2">
                  <div className="flex items-center gap-2 text-gray-700">
                    <FaShoppingCart className="text-gray-400" />
                    <span>পণ্যের মূল্য</span>
                  </div>
                  <span className="font-semibold">{subtotal}৳</span>
                </div>
                
                {/* Bump Products */}
                {bumps?.filter(b => b.selected).map((bump, index) => (
                  <div key={index} className="flex justify-between items-center mb-2 text-blue-600">
                    <span>{bump.title}:</span>
                    <span>+৳{Math.round(Number(bump.bump_price))}</span>
                  </div>
                ))}
                
                {deliveryCharge > 0 && (
                  <div className="flex justify-between items-center py-2">
                    <div className="flex items-center gap-2 text-gray-700">
                      <FaMapMarkerAlt className="text-gray-400" />
                      <span>ডেলিভারি চার্জ</span>
                    </div>
                    <span className="font-semibold text-green-600">{Math.round(Number(deliveryCharge))}৳</span>
                  </div>
                )}
                
                <div className="flex justify-between items-center pt-4 border-t border-gray-200">
                  <div className="flex items-center gap-2">
                    <span className="font-bold text-xl text-gray-800">মোট</span>
                  </div>
                  <div className="text-right">
                    <div className="font-bold text-2xl text-green-600">{total}৳</div>
                  </div>
                </div>
              </div>

              {/* Payment Method */}
              <div className="mb-6 p-4 bg-blue-50 rounded-xl">
                <div className="flex items-center gap-3 mb-3">
                  <div className="p-2 bg-white rounded-lg">
                    <FaMoneyBillWave className="text-green-600 text-xl" />
                  </div>
                  <h4 className="font-bold text-lg text-gray-800">পেমেন্ট পদ্ধতি</h4>
                </div>
                <div className="flex items-center gap-3 p-3 bg-white rounded-lg">
                  <input 
                    type="radio" 
                    id="cod" 
                    name="payment" 
                    checked 
                    readOnly 
                    className="w-5 h-5 text-green-600 focus:ring-green-500" 
                  />
                  <label htmlFor="cod" className="lg:font-semibold text-sm lg:text-md text-gray-700 cursor-pointer">
                    ক্যাশ অন ডেলিভারি (Cash on Delivery)
                  </label>
                </div>
                <p className="text-sm text-gray-600 mt-2 ml-8">
                  পণ্য হাতে পেয়ে টাকা পরিশোধ করুন। কোন অতিরিক্ত চার্জ নেই।
                </p>
              </div>


            {/* Bump Offer Card */}
            {bumps && bumps?.length > 0 && (
                 <div className="w-full mt-4 md:mt-6 bg-white p-3 md:p-4 rounded-lg md:rounded-xl shadow-sm md:shadow-md border border-gray-100">
                  <h3 className="text-lg md:text-xl font-semibold mb-3 md:mb-4 text-gray-800 flex items-center">
                    <span className="bg-blue-100 text-blue-800 rounded-full p-1.5 md:p-2 mr-2">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 md:h-5 md:w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
                      </svg>
                    </span>
                    বিশেষ অফার
                  </h3>
                  
                  <div className="space-y-3 md:space-y-4">
                    {bumps.map((bump) => (
                      <div 
                        key={bump.id}
                        onClick={() => handleBumpSelect(bump.id)}
                        className={`p-3 md:p-4 rounded-md md:rounded-lg border transition-all cursor-pointer hover:shadow-sm md:hover:shadow-md ${
                          bump.selected 
                            ? 'border-blue-500 bg-blue-50 ring-1 md:ring-2 ring-blue-200' 
                            : 'border-gray-200 hover:border-blue-300'
                        }`}
                      >
                        <div className="flex items-start">
                          <div className={`flex-shrink-0 h-4 w-4 md:h-5 md:w-5 rounded-full border flex items-center justify-center mr-2 md:mr-3 mt-0.5 md:mt-1 ${
                            bump.selected 
                              ? 'bg-blue-500 border-blue-500 text-white' 
                              : 'border-gray-300'
                          }`}>
                            {bump.selected && (
                              <svg className="h-2.5 w-2.5 md:h-3 md:w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                              </svg>
                            )}
                          </div>
                          
                          <div className="flex-1">
                            <div className="flex justify-between items-start">
                              <h4 className={`text-sm md:text-base font-medium ${
                                bump.selected ? 'text-blue-800' : 'text-gray-800'
                              }`}>
                                {bump.title}
                              </h4>
                              <span className="bg-green-100 text-green-800 text-xs md:text-sm font-medium px-2 py-0.5 rounded-full whitespace-nowrap">
                                +৳{Math.round(bump.bump_price)}
                              </span>
                            </div>
                            
                            <div className="mt-1.5 md:mt-2 flex flex-col md:flex-row items-start relative">
                              {bump.image && (
                                <img
                                  src={`${imageUrl}/${bump.image}`} 
                                  alt={bump.title}
                                  className="w-full md:w-32 h-auto md:h-32 object-cover rounded-md mr-0 md:mr-3 mb-2 md:mb-0"
                                />
                              )}
                              <p className="text-xs md:text-sm text-gray-600">{bump.description}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  
                  <p className="text-xs md:text-sm text-gray-500 mt-2 md:mt-3">
                    * বিশেষ অফারের পণ্যগুলো আপনার অর্ডারে যোগ করতে চাইলে ক্লিক করুন
                  </p>
                </div>
            )}

              {/* Order Confirm Button */}
              <button
                onClick={handleOrderConfirm}
                disabled={!name || !phone || !selectedDistrictName || isSubmitting}
                className={`w-full py-4 rounded-xl font-bold text-lg transition-all duration-300 transform hover:scale-[1.02] ${!name || !phone || !selectedDistrictName || isSubmitting
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 shadow-lg hover:shadow-xl'
                  }`}
              >
                <span className="text-white flex items-center justify-center gap-3">
                  <FaShoppingCart />
                  {isSubmitting ? 'প্রসেসিং হচ্ছে...' : `অর্ডার কনফার্ম করুন – ${total}৳`}
                </span>
              </button>
              
              {/* Security Assurance */}
              <div className="mt-4 text-center">
                <p className="text-sm text-gray-600 flex items-center justify-center gap-2">
                  <svg className="w-4 h-4 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  ১০০% সিকিউর পেমেন্ট | প্রাইভেসি প্রোটেক্টেড
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Help Section */}
       <HelpSectuion />
      </div>
    </div>
  );
};

export default CheckoutSection;